// extracted by mini-css-extract-plugin
export var card = "_v9-0";
export var details = "_v9-1";